import React, { useEffect, useState } from 'react';
import Image from '@plasma/ui.display.image';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { AllCompaniesProps } from './all-companies';
import help from './all-companies.help';
import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import notification from '@plasma/ui.feedback.notification';

import allCompaniesColumns from '../../types/allCompaniesDatatype';
import { putData_byApiNameAndData } from '../../services/puts/putdata';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useAllCompaniesHook(props: AllCompaniesProps) {
  useResourceBundle(translations, undefined, 'bc86aff9-642d-4ea9-b647-67345a999f40');
  useHelpBundle(help);

  const { t } = useTranslation();
  const [dataForColumns, setdataForColumns] = useState([]);
  // const [convertedDataForColumns, setconvertedDataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(allCompaniesColumns());
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFromData] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const [zipCodeErrorMessage, setZipCodeErrorMessage] = useState('');

  //const [hiddenColumns] = useState(['remarks']);
  const handleSelectedRow = (rowIndex) => {
    console.log('selected row', dataForColumns[rowIndex]);
    setFromData(dataForColumns[rowIndex]);
    setModalVisible(true);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleSaveFromModal = () => {
    console.log(formData);
    putData_byApiNameAndData("UpdateCompanyInfo", formData, apiUriMasterDataHttp()).then((resposne) => {
      notification.success("Saved Successfully!");
      fetchAllCompanies();
    })
    setModalVisible(false);
  };

  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllCompanies = () => {

    fetchAllDataGet_byApiName('GetMasterCompanies', apiUriMasterDataHttp())
    .then((data) => {
      setdataForColumns(Array.isArray(data) ? data : []);
    })
    .catch((error) => {
      console.log('Failed to Fetch companies');
    });

  }

  const dataChangedHandler = (fieldName: string, value: string)=>{
    setFromData({
      ...formData,
      [fieldName]: value,
    });
  }


  return {
    t,
    dataForColumns,
    columnNames,
    handleSelectedRow,
    modalVisible,
    handleModalCancel,
    handleSaveFromModal,
    formData,
    errorMessage,
    setErrorMessage,
    dataChangedHandler,
    zipCodeErrorMessage,
    setZipCodeErrorMessage
  };
}

export default useAllCompaniesHook;
